import LinearProgress from '@mui/joy/LinearProgress';

export default function LinearProgressThickness() {
  return <LinearProgress thickness={1} />;
}
